// Action Types for Routes
export const ACTION_UPDATE_CURRENT_ROUTE = 'UPDATE_CURRENT_ROUTE';
